import React from "react";
import {
  PLAIN_CLICK_PIN_COLOR,
  SELECTED_PIN_OUTLINE_COLOR,
  TEARDROP_PATH,
} from "../utils/canvasPin/teardropPin";

type PinLegendIconProps =
  | {
      /** 地図と同じしずく型のピン */
      kind: "teardrop";
      color: string;
      /** 選択中の黄色い外縁を付けるか */
      selected?: boolean;
    }
  | {
      /** 情報が出ないクリック地点の灰色の丸 */
      kind: "plain";
    };

/**
 * 凡例に出すピンの見本。地図の Canvas と同じ輪郭・色を SVG で描く
 */
export const PinLegendIcon: React.FC<PinLegendIconProps> = (props) => {
  if (props.kind === "plain") {
    return (
      <svg
        width="14"
        height="20"
        viewBox="0 0 14 20"
        aria-hidden="true"
        data-pin-color={PLAIN_CLICK_PIN_COLOR}
      >
        <circle cx="7" cy="10" r="5.5" fill="#ffffff" />
        <circle cx="7" cy="10" r="4" fill={PLAIN_CLICK_PIN_COLOR} />
        <circle cx="7" cy="10" r="1.5" fill="#ffffff" />
      </svg>
    );
  }

  const { color, selected = false } = props;
  return (
    <svg
      width="14"
      height="20"
      viewBox="-2 -2 18 24"
      aria-hidden="true"
      data-pin-color={color}
    >
      {selected && (
        <path
          d={TEARDROP_PATH}
          fill="none"
          stroke={SELECTED_PIN_OUTLINE_COLOR}
          strokeWidth="4"
          strokeLinejoin="round"
        />
      )}
      <path
        d={TEARDROP_PATH}
        fill={color}
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="7" r="2.6" fill="#ffffff" />
    </svg>
  );
};
